module.exports = __webpack_public_path__ + "static/media/DNA-based-Processing.ae5f5c92.svg";